import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FeaturedCardMultiLinks from "@components/featured/FeaturedCardMultiLinks";
import PageH1 from "@components/seo/PageH1";
import { useWindow } from "@hooks/useWindow";
import { mockRandomArr } from "@utils/helpers";
import MultiLinksCardSkeleton from "./MultiLinksCardSkeleton";
const MultiLinksCardsGrid = ({ title, description, cards, isMultiLinks }) => {
    const myWindow = useWindow();
    const hasCards = !!cards && cards.length !== 0;
    const shouldRender = !!myWindow && hasCards;
    return (_jsxs("section", { className: "multi-links-grid container", children: [title && (_jsx(PageH1, { fallbackElement: "h2", className: "multi-links-grid__title", children: title })), description && _jsx("p", { className: "multi-links-grid__sub-title", dangerouslySetInnerHTML: { __html: description } }), _jsx("div", { className: "multi-links-grid__cards", children: !shouldRender
                    ? mockRandomArr(8).map((idx) => _jsx(MultiLinksCardSkeleton, {}, idx))
                    : hasCards && cards.map((card, index) => _jsx(FeaturedCardMultiLinks, { featuredItem: card, isMultiLinks: isMultiLinks }, card.title + index)) })] }));
};
export default MultiLinksCardsGrid;
